<template>
  <b-tab title="Fornecedores" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE FORNECEDORES :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterFornecedores(filtro)" :fields="fields.fornecedor">
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="10" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="fornecedor-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Filtre pelo nome do fornecedor."
              v-model="filtro"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <fornecedor-modal ref="editor" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useFornecedorStore } from "@/stores/FornecedorStore";
import Fornecedor from "@/models/Fornecedor";
import TableFields from "@/tools/TableFields";
import FornecedorModal from "@/components/modals/fornecedor/FornecedorModal";

export default {
  name: "FornecedorTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: "",
      fornecedor: new Fornecedor(0, "Novo Fornecedor", "", "", "", "", "", "", ""),
    };
  },

  components: {
    "fornecedor-modal": FornecedorModal,
  },

  methods: {
    adicionar() {
      this.fornecedor = new Fornecedor(0, "Novo Fornecedor", "", "", "", "", "", "", "");
      this.$refs.editor.call(this.fornecedor);
    },

    editar(fornecedor) {
      this.$refs.editor.call(fornecedor);
    },
  },

  setup() {
    const store = useSgcqStore();
    const fornecedorStore = useFornecedorStore();
    const { getFilterFornecedores } = storeToRefs(fornecedorStore);

    return {
      store,
      fornecedorStore,
      getFilterFornecedores,
    };
  },
};
</script>

<style lang="scss" scoped>
#fornecedor-filter {
  width: 30rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
